import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { authConfig } from './config/auth';
import ProtectedRoute from './components/ProtectedRoute';
import EmbedWrapper from './components/embed/EmbedWrapper';
import EmbedPage from './components/embed/EmbedPage';
import SettingsPage from './components/SettingsPage';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <GoogleOAuthProvider clientId={authConfig.googleClientId}>
        <AuthProvider>
          <Routes>
            <Route path="/embed/:section/:widget?" element={<EmbedWrapper><EmbedPage /></EmbedWrapper>} />
            <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
            <Route path="/*" element={<ProtectedRoute><App /></ProtectedRoute>} />
          </Routes>
        </AuthProvider>
      </GoogleOAuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
